export class OfficialDispatchToken {
  static IOfficialDispatchRepository = Symbol("IOfficialDispatchRepository");
  static OfficialDispatchUseCase = Symbol("OfficialDispatchUseCase");
  static OfficialDispatchViewModel = Symbol("OfficialDispatchViewModel");
}
